import { Grid } from '@mui/material';
import { StatisticWithLabelColored } from '@tassat/statistic';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getStatistics } from 'Selectors/common';
import AssetBalancesChart from 'SharedComponents/assetBalancesChart';

import AssetBalances from '../assetBalances';
import FirmOverviewTable from '../firmOverview';
import LiquidityFacilityOverviewTable from '../liquidityFacilityOverview';

import type { OpsAdminDashboardProps } from '.';

const OpsAdminDashboard = (props: OpsAdminDashboardProps) => {
    const {
        classes,
        setAssetListOverlayOpen
    } = props;
    const labeledStatistics = useAppSelector(getStatistics);

    return (
        <Grid
            className={classes.statisticsBackground}
            container
            direction='column'
            wrap='nowrap'
        >
            <Grid
                className={classes.assetsBalancesContainer}
                item
                xs={12}
            >
                <AssetBalances setAssetListOverlayOpen={setAssetListOverlayOpen} />
            </Grid>
            <Grid
                container
                direction='row'
            >
                <Grid
                    container
                    item
                    xs={6}
                >
                    <Grid
                        className={classes.labeledStatistics}
                        container
                        item
                        wrap='nowrap'
                    >
                        <Grid
                            className={classes.labelStats}
                            item
                            xs={4}
                        >
                            <StatisticWithLabelColored
                                sideColumnColor='#EA3323'
                                statistic={{
                                        title: 'Failed Transactions',
                                        statistic: labeledStatistics.FailedTransactionCount.toString()
                                    }}
                            />
                        </Grid>
                        <Grid
                            className={classes.labelStats}
                            item
                            xs={4}
                        >
                            <StatisticWithLabelColored
                                sideColumnColor='#3C4F70'
                                statistic={{
                                        title: 'Logged In Client Users',
                                        statistic: labeledStatistics.ClientLoggedInCount.toString()
                                    }}
                            />
                        </Grid>
                        <Grid
                            className={classes.labelStats}
                            item
                            xs={4}
                        >
                            <StatisticWithLabelColored
                                sideColumnColor='#4499D9'
                                statistic={{
                                        title: 'Logged in Admin Users',
                                        statistic: labeledStatistics.AdminLoggedInCount.toString()
                                    }}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        className={classes.assetsBalancesContainer}
                        item
                        xs={12}
                    >
                        <FirmOverviewTable />
                    </Grid>
                    <Grid
                        className={classes.lfStatsContainer}
                        item
                        xs={12}
                    >
                        <LiquidityFacilityOverviewTable />
                    </Grid>
                </Grid>
                <Grid
                    container
                    item
                    xs={6}
                >
                    <AssetBalancesChart
                        margin={{
                                t: 48,
                                b: 48
                            }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default OpsAdminDashboard;